export function viewFileType(index) {
  let value;
  if (index == 1) value = "Nhận xét/ đánh giá";
  else if (index == 2) value = "Tệp tin";
  else if (index == 3) value = "Biến động";
  else if (index == 4) value = "Công tác";
  else if (index == 5) value = "Lương";
  else if (index == 6) value = "Đào tạo";
  else if (index == 7) value = "Gián đoạn lao động";
  else if (index == 8) value = "Khen thưởng";
  else if (index == 9) value = "Kỷ luật";
  else if (index == 10) value = "Phụ cấp";
  else if (index == 11) value = "Nghỉ việc";
  else value = "";
  return value;
}

export function importFileType(key) {
  let value;
  if (key == "NhanXetDanhGia") value = 1;
  else if (key == "TepTin") value = 2;
  else if (key == "BienDong") value = 3;
  else if (key == "CongTac") value = 4;
  else if (key == "Luong") value = 5;
  else if (key == "DaoTao") value = 6;
  else if (key == "GianDoan") value = 7;
  else if (key == "KhenThuong") value = 8;
  else if (key == "KyLuat") value = 9;
  else if (key == "PhuCap") value = 10;
  else if (key == "NghiViec") value = 11;
  return value;
}
